"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountSearchParams = mountSearchParams;
exports.isElement = isElement;
exports.validateRequiredFields = validateRequiredFields;
function mountSearchParams(parameters) {
    if (parameters === void 0) { parameters = {}; }
    return Object.keys(parameters).map(function (key) { return key + '=' + parameters[key]; }).join('&');
}
function isElement(element) {
    return element instanceof Element;
}
function validateRequiredFields(object, requiredFields) {
    var isValid = true;
    var invalidField = null;
    requiredFields.forEach(function (field) {
        var hasField = Object.keys(object).includes(field);
        if (!hasField) {
            isValid = false;
            invalidField = field;
        }
    });
    return { isValid: isValid, invalidField: invalidField };
}
